import Utilities from './Utilities';
export default {
  methods: {
    meetsDisplayConditions(display) {
      const defaultDisplayMode =
        typeof display.default !== 'undefined' ? display.default : 'show';
      const defaultDisplay = defaultDisplayMode === 'show';
      const satisfiedConditions = [];
      let satisfiesConditions = true;
      const conjunction =
        typeof display.conjunction !== 'undefined' ? display.conjunction : 'OR';
      const conditionList = Utilities.dig(display, ['conditions'], []);
      if (conditionList.length > 0) {
        // eslint-disable-next-line no-unused-vars
        for (const condition of conditionList) {
          if (condition.type === 'question') {
            satisfiedConditions.push(this.evaluateQuestionCondition(condition));
          } else if (condition.type === 'variable') {
            satisfiedConditions.push(this.evaluateVariableCondition(condition));
          } else if (condition.type === 'score') {
            satisfiedConditions.push(this.evaluateScoringCondition(condition));
          }
          if (satisfiedConditions.indexOf(false) !== -1) {
            if (conjunction === 'AND') {
              satisfiesConditions = false;
              break;
            }
          }
        }
      } else {
        return defaultDisplay;
      }

      if (conjunction === 'OR' && satisfiedConditions.indexOf(true) === -1) {
        satisfiesConditions = false;
      }

      if (satisfiesConditions && !defaultDisplay) {
        return true;
      } else if (satisfiesConditions && defaultDisplay) {
        return !defaultDisplay;
      } else {
        return defaultDisplay;
      }
    },
    evaluateScoringCondition(condition) {
      // this all depends on scores being available!
      const scoreSet = condition.left;
      const scoreQuery = condition.query;
      const input = this.$store.state.scoreCache[scoreSet][scoreQuery];
      return this.evaluateNumericCondition(input, condition);
    },
    evaluateQuestionCondition(condition) {
      const schema = this.$store.getters.questionSchema;
      const input = this.$store.getters.flattenedAnswers[condition.left];
      // copy the condition so we don't re-trigger render
      const conditionCopy = JSON.parse(JSON.stringify(condition));

      if (typeof schema[condition.left] !== 'undefined') {
        // this question has keyed answers, so replace the condition.right
        // (which is an answer key) with the answer value.
        // This should all be replaced by a system which uses keys on client and server
        // but we have to this currently for hysterical reasons

        const matchedAnswers = schema[condition.left].filter(
          answer => answer.key === conditionCopy.right
        );
        if (matchedAnswers.length > 0) {
          conditionCopy.right = matchedAnswers[0].value;
        }
      }

      return this.evaluateTextCondition(input, conditionCopy);
    },
    evaluateVariableCondition(condition) {
      return this.evaluateTextCondition(
        this.$store.state.config.account[condition.left],
        condition
      );
    },
    evaluateNumericCondition(input, condition) {
      let success = false;
      if (condition.band) {
        const scoreSet = this.getScoreSetById(condition.left);
        condition.operator = 'inRange';
        const band = this.getScoreBandById(scoreSet.bands, condition.band);
        condition.right = [band.min, band.max];
      }
      switch (condition.operator) {
        case 'lt':
          success = input < condition.right;
          break;
        case 'lte':
          success = input <= condition.right;
          break;
        case 'eq':
          success = input === condition.right;
          break;
        case 'gt':
          success = input > condition.right;
          break;
        case 'gte':
          success = input >= condition.right;
          break;
        case 'inRange':
          success = input >= condition.right[0] && input <= condition.right[1];
          break;
      }
      return success;
    },
    evaluateTextCondition(input, condition) {
      let pass;
      let valuesMatch;
      if (Array.isArray(input)) {
        // this is a multiselect
        valuesMatch = input.indexOf(condition.right) !== -1;
      } else {
        valuesMatch = condition.right === input;
      }
      if (
        (valuesMatch && condition.operator === 'is') ||
        (!valuesMatch && condition.operator === 'isNot')
      ) {
        pass = true;
      } else if (
        (valuesMatch && condition.operator === 'isNot') ||
        (!valuesMatch && condition.operator === 'is')
      ) {
        pass = false;
      } else {
        pass = false;
      }
      return pass;
    },
  },
};
